import PropTypes from 'prop-types';
import { useCallback, useMemo } from 'preact/hooks';

FriendsgivingPollSelector.propTypes = {
  onPollSelected: PropTypes.func,
  disabled: PropTypes.bool,
  polls: PropTypes.array,
  pollsLoading: PropTypes.bool,
  pollID: PropTypes.any,
};

export default function FriendsgivingPollSelector({
  onPollSelected,
  disabled = false,
  polls,
  pollsLoading,
  pollID = null,
}) {
  const setSelectedPoll = useCallback(
    (e) => {
      const pollID = e.target.value;
      const goal = polls.find((poll) => poll.id === pollID).goal;
      onPollSelected({ id: pollID, goal });
    },
    [polls, onPollSelected]
  );

  const pollOptions = useMemo(
    () =>
      polls.map((poll) => {
        return (
          <option title={poll.name} value={poll.id} key={poll.id} id={poll.id}>
            {poll.name}
          </option>
        );
      }),
    [polls]
  );

  if (pollsLoading)
    return (
      <label className="form-control w-full">
        <div className="label">
          <span className="label-text">Friendsgiving Poll</span>
        </div>
        <div className="select skeleton" />
        <div className="label">
          <span className="label-text-alt">Loading polls...</span>
        </div>
      </label>
    );

  return (
    <fieldset className="fieldset">
      <legend className="fieldset-legend">Friendsgiving Poll</legend>
      <select
        className="select select-bordered w-full"
        onChange={setSelectedPoll}
        disabled={disabled}
        value={pollID === null || pollID === undefined ? 'null' : pollID}
      >
        <option
          title="Please select a poll"
          value="null"
          disabled
          selected={pollID === null || pollID === undefined}
        >
          Please select a poll
        </option>
        {pollOptions}
      </select>
      <span className="label">
        {polls.length} poll{polls.length === 1 ? '' : 's'}
      </span>
    </fieldset>
  );
}
